export enum PurchaseOrderStatusEnum {
  GENERATED = 'GENERATED',
  REFUSED_BY_SUPPLIER = 'REFUSED_BY_SUPPLIER',
  VALIDATED = 'VALIDATED',
  CANCELLED = 'CANCELLED',
  AMENDED = 'AMENDED',
  EXPIRED = 'EXPIRED' // It seems it is technical (Not exists on the BE)
}
